export enum NodeConfigPropertyType {
  Text,
  Boolean,
  Integer,
  CustomObject,
  Decimal,
  EnabledInputs,
  EnabledOutputs,
  ViewDataSourceDetails,
  Enum,
  DataSource,
  Schema,
  SchemaProperty,
  StandardObject,
  DataOutputs,
  DataInputs,
  DataPropertyCount,
  DataType,
  DataValue,
  FlowInputDataEditor,
  Position,
  NoInput,
  Event,
  Actions,
  LoopVariableEditor,
  PlexOpenApi,
  ExternalApiEndpoint,
  PlexAgent,
  ConnectedSchemaTags,
  MlModel,
  TemplateEditor
}

export const writesDocument = (type: NodeConfigPropertyType) => {
  if (
    type === NodeConfigPropertyType.EnabledInputs ||
    type === NodeConfigPropertyType.EnabledOutputs ||
    type === NodeConfigPropertyType.FlowInputDataEditor ||
    type === NodeConfigPropertyType.LoopVariableEditor
  ) {
    return false;
  }

  return true;
};
